module.exports = __webpack_public_path__ + "img/pic_3.8442dadc.png";